import React, { Component } from "react";

import LandingPage from "./LandingPage/LandingPage";
import InitialForm from "./InitialForm/InitialForm";
import '../assets/styles/style.css';
import apiService from "./Services/APIService";
import HWUser from "./HWLibrary/HWUser";
import 'react-block-ui/style.css'; 
import xmppService from './Services/XMPPService';
import HWLog from "./HWLibrary/HWLog";
import ConversationPage from "./Conversation/ConversationPage";
import StartUp from "./StartUp";
import { s360ConfigService } from "./Services/S360Config";
import ActivityIndicator from "./CommonUtils/ActivityIndicator";
// import ErrorMessagePage from "./CommonUtils/ErrorMessagePage";
import PopUpMessage from "./CommonUtils/PopUpMessage";
import { sendOnAppOpen, sendOnAppClose } from "./Services/HWIframeBridge";
class Simplify360Chat extends Component {

    constructor(props) {
        super(props);
        const isLoggedIn = HWUser.isLoggedIn();
        HWLog.info("Is Logged In: "+ isLoggedIn);
     
        const showForm   = s360ConfigService.config.configDetails.showForm;
        let firstPage  = !isLoggedIn && showForm ? Simplify360Chat.pageName.initialForm : Simplify360Chat.pageName.landingPage;
        firstPage=  (s360ConfigService.config.configDetails.offline)?"offlinePage":firstPage;
        let showActivityIndicator = isLoggedIn ? false: !(!isLoggedIn && showForm);
        this.state       = { visiblePage: firstPage , isAppOpen: false , showForm: showForm, showPopUpMessage: false, showActivityIndicator: showActivityIndicator,goback:false}; 
    }

    static pageName = {         // enum
        initialForm:      'initialForm', 
        landingPage:      'landingPage', 
        conversationPage: 'conversationPage',
        offlinePage: 'offlinePage',
    };      

    render() {
        HWLog.info("MAIN PAGE RENDER");
        let isLoggedIn = HWUser.isLoggedIn();
        console.log(this.state)
        return (  
            
            <>
            {(<StartUp actions={this.actions} />)}
            {this.state.isAppOpen && (
            <div className="s360-main-float-container" style={this.containerStyle()} >
                { this.state.visiblePage === Simplify360Chat.pageName.offlinePage       && (<InitialForm        key={"inital-form-" + false}       config={s360ConfigService.config} actions={this.actions} {...this.state} />) }
                { this.state.visiblePage === Simplify360Chat.pageName.initialForm       && (<InitialForm        key={"inital-form-" + isLoggedIn}       config={s360ConfigService.config} actions={this.actions} {...this.state} />) }
                { this.state.visiblePage === Simplify360Chat.pageName.landingPage       && (<LandingPage        key={"landing-page-" + isLoggedIn}      config={s360ConfigService.config} actions={this.actions} {...this.state} />) } 
                { this.state.visiblePage === Simplify360Chat.pageName.conversationPage  && (<ConversationPage   key={"conversation-page-" + isLoggedIn} config={s360ConfigService.config} actions={this.actions} {...this.state} />) } 
                { this.state.showActivityIndicator && (<ActivityIndicator config={s360ConfigService.config} actions={this.actions} {...this.state} />) } 
                { this.state.showPopUpMessage  && <PopUpMessage popUpMessage={this.state.popUpMessage}  onClose={this.state.closeAction} /> }
            </div>
            )}
            </>
        )
    }

    componentDidMount() {
        if (this.state.isAppOpen) {
            this.checkAndAutoLogin();
        }
    }

    actions = {
        startChat: (formDetails)     => { this.login(formDetails);          },
        startConversation: (details, completionHandler) => { this.startConversation(details, completionHandler);  },
        showLandingScreen: ()        => { this.moveToPage(Simplify360Chat.pageName.landingPage); },
        onStartUpClick:   ()         => { this.onStartUpClick(); },
        markActiveConversationAsClosed: () => { this.markActiveConversationAsClosed(); },
        onHideChatWindow: ()         => { this.setState({ isAppOpen: false })},
        showPopUpMessage: (message)  => { this.showPopUpMessage(message); },
        submitForm: (contactFormDetails) => {this.submitForm(contactFormDetails);},
        showPopUpMessageAction: (message)  => { this.showPopUpMessageAction(message); },
        closePopup: ()   => {this.closePopup();} 
    }

    checkAndAutoLogin = () => {
        s360ConfigService.loadClientConfigFromToken();
        if(!HWUser.isLoggedIn() && s360ConfigService.config.configDetails.showForm === false && this.state.isAppOpen) {
            // Auto Login
            let configFormDetails = {...s360ConfigService.s360UserConfig};
            
            this.login(configFormDetails);
            
            // alert("AUTO LOGIN");
        }
    }

    onStartUpClick = () => {
        let updatedState = !this.state.isAppOpen;
        if (updatedState) { sendOnAppOpen(); }
        else { sendOnAppClose(); }

        this.setState({ isAppOpen: updatedState }, () => {
            this.checkAndAutoLogin();
        }); 
    }

    login = (formDetails) => {
        return apiService.logInWithFormData(formDetails).then(loginResult => {
            HWLog.info("LOGIN Result: ", loginResult.data);
            if (!loginResult.data || loginResult.data.error) {
                this.setState({errorMessage: loginResult.data.error || ''}, () => {
                    this.showPopUpMessage(loginResult.data.error || 'Something went worng. Please try again.');
                });
            } else {
              HWUser.updateUserDetails(loginResult.data);
              this.setState({ showActivityIndicator: false }, () => {
                this.moveToPage(Simplify360Chat.pageName.landingPage); // XMPP connection is handled on landing screen.
              })
            }
        }).catch(this.onAPIError)
    }

    markActiveConversationAsClosed = () => {
       if (this.state.activeConversation) {
           let activeConversation    = this.state.activeConversation;
           activeConversation.active = false;
           HWLog.info("MARKED ACTIVE CONVERSATION AS CLOSED:");
           this.setState({ activeConversation: activeConversation });
       }
    }

    showPopUpMessage = (message) => {
        if (!message) { return }
        this.setState({ showPopUpMessage: true, popUpMessage: message, showActivityIndicator: false, closeAction:this.closePopup});
    }


    showPopUpMessageAction = (message) => {
        if (!message) { return }
        this.setState({ showPopUpMessage: true, popUpMessage: message, showActivityIndicator: false, closeAction:this.goToHome});
    }

    // Moves to existing conversation.
    startConversation = (conversationDetials, completionHandler) => {
        this.setState({activeConversation: conversationDetials}, () => {
            this.moveToPage(Simplify360Chat.pageName.conversationPage, completionHandler);
        });
    }

    moveToPage = (pageName, onStateUpdate) => {
        this.setState({visiblePage: pageName}, () => {  onStateUpdate && onStateUpdate(); });
    }

    configureAndConnectToXMPP = (xmpppConfig) => {
        xmppService.configure(xmpppConfig).catch(this.onAPIError)
    }

    onAPIError = (error) => {
        let messageToShow = (error && error.message === "Network Error") ?  "Please check your internet connectivity.": "Could not connect to server, please try again.";    
        HWLog.error(error, messageToShow);
        this.showPopUpMessage(messageToShow);
        // alert("Could not connect to the server. Please try again.");
    }

    containerStyle = () => {
        return {
            background: s360ConfigService.config.designDetails.headerBackgroundImage !== undefined && s360ConfigService.config.designDetails.headerBackgroundImage !== ""?("url("+s360ConfigService.config.designDetails.headerBackgroundImage+")"):s360ConfigService.config.designDetails.headerColor,
            borderColor: s360ConfigService.config.designDetails.headerColor,
            borderStyle: "none",
            borderWidth: "0.5px",
            borderRadius: "10px",
            // height:"640px",
            // width:"360px"
        }
    }


    submitForm = (contactFormDetails,func) => {
        return apiService.createTicketWithFormData(contactFormDetails).then(result => {
            HWLog.info("Contact form result: ", result.data);
            if (!result.data || result.data.error) {
                this.setState({errorMessage: result.data.error || ''}, () => {
                    this.showPopUpMessageAction(result.data.error || 'Something went worng. Please try again.');
                });
            } else {
                this.showPopUpMessageAction('Form submitted successfully');
            }
        }).catch(this.onAPIError)
    }

    goToHome = () => {
        this.setState({ showPopUpMessage: false, popUpMessage: null,goback:true});
    }

    closePopup = () => {
        this.setState({ showPopUpMessage: false, popUpMessage: null });
    }
    

}

export default Simplify360Chat;